export default __webpack_public_path__ + "static/media/mastercard.9682355b.svg";